import React, { PureComponent } from 'react';

import styled from 'styled-components';

import WarningIcon from '@public/icons/warning.svg';
import { breakpoint } from 'theme';

type IconWarningProps = {
  className?: string;
};

class IconWarning extends PureComponent<IconWarningProps> {
  render() {
    return <WarningIcon role="img" className={this.props.className} />;
  }
}

const styledIconWarning = styled(IconWarning)`
  position: absolute;
  right: 12px;
  bottom: 16px;

  ${breakpoint.m`
    bottom: 6px;
    width: 30px;
    height: 30px;
  `}
`;

export default styledIconWarning;
